/**
 * @generated SignedSource<<06b30fff81deb6c9145868aacd1b6057>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type getCachedPageDataSubTypePageTreeFragment$data = {
  readonly id: string;
  readonly subType: string | null;
  readonly " $fragmentType": "getCachedPageDataSubTypePageTreeFragment";
};
export type getCachedPageDataSubTypePageTreeFragment$key = {
  readonly " $data"?: getCachedPageDataSubTypePageTreeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"getCachedPageDataSubTypePageTreeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "getCachedPageDataSubTypePageTreeFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    }
  ],
  "type": "PTPage"
};

(node as any).hash = "7ccb76f2a832d90b6f167fe96a11f5a9";

export default node;
